// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__JAlQl","paramInput":"JobSimulator_paramInput__3T8hK","input":"JobSimulator_input__gWBse"};